module.exports = __webpack_public_path__ + "assets/img/jyrw2.e56b7909.jpg";